export default "__VITE_ASSET__CcEG6ZZw__"